import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CurrencyFormat from "react-currency-format";
import CardContent from "@material-ui/core/CardContent";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ViewDetailedReport from "./ViewDetailedReport";
import MyGallery from "./ImageGallery";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos"
import {
  getInspectionDamageDetailsApi,
  getOEMBuildDetailsApi,
  getInspectionVehicleDetails,
  getInspectionAccessoryDetails,
  getInspectionWheelTiresDetails,
} from "../service/api";
import moment from "moment";
import { Box } from "@material-ui/core";
import UpdateMileagePricing from "../components/UpdateMileagePricing";
import ArbitrationReviewpage from "../pages/ArbitrationReviewPage";

export default function ConditionReportRequests(props) {
  const history = useHistory();
  const pageName = props?.location?.state?.pageName || props.pageData?.pageName;
  const [open, setOpen] = React.useState(false);
  const [condionVehicleDetails, setCondionVehicleDetails] = React.useState({});
  const [inspectionId, setInspectionId] = React.useState([]);
  const vin = props?.location?.state?.vin || props.pageData?.vin;
  const [accessoryDetails, setAccessoryDetails] = React.useState([]);
  const [wheelTiresDetails, setWheelTiresDetails] = useState([]);
  const [DamageDetails, setDamageDetails] = useState([]);
  const [OEMBuildDetailsData, setOEMBuildDetailsData] = useState([]);
  const vehicleDetails = props?.location?.state?.vehicleDetails || props.pageData?.vehicleDetails;
 
  useEffect(() => {
    if (vin) {
      getOEMBuildDetails();
      getInspectionAccessory();
      getConditionVehicleDetails();
    }
  }, [vin]);

  useEffect(() => {
    if (inspectionId >0) {
      getInspectionWheelTires();
      getInspectionDamageDetails();
    }
  }, [inspectionId]);

  async function getOEMBuildDetails() {
    if (vin) {
      const apiResponse = await getOEMBuildDetailsApi(vin);
      setOEMBuildDetailsData(apiResponse?.data);
    }
  }

  async function getInspectionAccessory() {
    if(vin) {
      const apiResponse = await getInspectionAccessoryDetails(vin);
      setAccessoryDetails(apiResponse?.data);
    }
  }

  async function getConditionVehicleDetails() {
    const apiResponse = await getInspectionVehicleDetails(vin);
    console.log("getConditionVehicleDetailsresponse", apiResponse);
    if (apiResponse && apiResponse?.data) {
      setCondionVehicleDetails(apiResponse?.data);
      if (apiResponse?.data?.inspection_id) { 
        setInspectionId(apiResponse?.data?.inspection_id);
      }
    }
  }

  async function getInspectionDamageDetails() {
    if (inspectionId > 0 && vin) {
      const getInspectionDamageDetailsaApiResponse =
        await getInspectionDamageDetailsApi(inspectionId, vin);
      setDamageDetails(getInspectionDamageDetailsaApiResponse?.data);
    }
  }

  async function getInspectionWheelTires() {
    const apiResponse = await getInspectionWheelTiresDetails(inspectionId);
    console.log("wheelTiresDetailsapires", apiResponse);
    setWheelTiresDetails(apiResponse?.data);
  }

  const handleOpen = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(!open);
  };
  const milesFormatter = new Intl.NumberFormat('en-US');
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });

  return (
    <>
      <div className="conditionTopBar">
        <Box p={1} textAlign="right">
          <Link
            to={{
              pathname: "/adminInventoryRequests",
              state: { pageName: pageName },
            }}
          >
            {pageName}
          </Link>
        </Box>
      </div>
      <Box mt={2}>
        <Box display={'flex'} width={'100%'} >
          <Box className="conditional-report-body">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box display={'flex'} alignItems={'center'}>
                  <ArrowBackIos />
                  <Button
                    underline="hover"
                    key="2"
                    color="inherit"
                    onClick={(e)=>{
                      history.goBack();
                    }}
                  >
                    {pageName}
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={5}>
              <div className="codereportimggallery">
                {condionVehicleDetails && Object.keys(condionVehicleDetails)?.length ? <MyGallery {...condionVehicleDetails} /> : null}
                </div>
                <Grid container className="ConditionCardBody">
                  <div className="damageTitle">
                    <span>Damage Report</span>
                  </div>
                  <Grid item xs={4}>
                    <Card className="ConditionCardDamage">
                      <CardContent>
                        <div className="smallCardTitle">Exterior total</div>
                        <div className="smallCardBody warningColor">
                          {DamageDetails && DamageDetails.exteriorCost ? formatter.format(DamageDetails.exteriorCost) : (
                            "$0.00"
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className="ConditionCardDamage">
                      <CardContent>
                        <div className="smallCardTitle">Interior total</div>
                        <div className="smallCardBody warningColor">
                          {DamageDetails && DamageDetails.interiorCost ? formatter.format(DamageDetails.interiorCost) : (
                            "$0.00"
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className="ConditionCardDamage">
                      <CardContent>
                        <div className="smallCardTitle">Mechanical total</div>
                        <div className="smallCardBody warningColor">
                          {DamageDetails && DamageDetails.maintainenceCost ? formatter.format(DamageDetails.maintainenceCost) : (
                            "$0.00"
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid className="center-aligin-btn" mt={2} mb={2} item xs={12}>
                    <Button
                      variant="outlined"
                      color="primary"
                      className="detailedReport "
                      onClick={handleOpen}
                    >
                      View Full Detailed Report
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="disclaimer">
                      Disclaimer: Damage estimates are included for reference and
                      may not be reflective of the actual repair costs
                    </div>
                  </Grid>
                </Grid>
                <div className="LabelTextTextArea">Announcements</div>
                <TextareaAutosize
                  className="inputFieldTextArea"
                  aria-label="maximum height"
                  placeholder="Maximum 4 rows"
                  defaultValue="Text area describes when a vehicle may have possible structural damage. This is non editable text/container, but you can drag the container corner for more height if the user wants to see more info without having to scroll, if there is a lot of copy. "
                />
              </Grid>
              <Grid item xs={7}>
                <Box display="flex" justifyContent="space-between" py={2}>
                  <div className="reportTitle">
                    {/* console.log(JSON.stringify(condionVehicleDetails)) */}
                    <span>{vehicleDetails && vehicleDetails.modelYear}{" "}
                            {vehicleDetails && vehicleDetails.make}{" "}
                            {vehicleDetails && vehicleDetails.model}{" "}
                            
                             </span>
                  </div>
                  <span className="ConditionReportInspection">
                    <span className="BadgeValue">Inspection Complete</span>
                  </span>
                </Box>
                <Grid container spacing={2}>
                  <Grid item md={4}>
                    <Card className="ConditionCard">
                      <CardContent>
                        <div className="smallCardTitle">Payoff</div>
                        <div className="smallCardBody">     {condionVehicleDetails &&
                              condionVehicleDetails?.currentPayoffAmount ? (
                                <CurrencyFormat
                                  value={parseFloat(
                                    condionVehicleDetails?.currentPayoffAmount
                                  ).toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              ) : (
                                "$0.00"
                              )}</div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={4}>
                    <Card className="ConditionCard">
                      <CardContent>
                        <div className="smallCardTitle1">Residual + Remaining</div>
                        <div className="smallCardBody">         {condionVehicleDetails &&
                              condionVehicleDetails?.totalOutstandingRemainingPayments &&
                              condionVehicleDetails?.residual ? (
                                <CurrencyFormat
                                  value={condionVehicleDetails?.totalOutstandingRemainingPayments > 0 ? parseFloat(
                                    condionVehicleDetails?.residual +
                                    condionVehicleDetails?.totalOutstandingRemainingPayments
                                  ).toFixed(2) : parseFloat(condionVehicleDetails?.residual).toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              ) : (
                                "$0.00"
                              )}</div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={4}>
                    <Card className="ConditionCard">
                      <CardContent>
                        <div className="smallCardTitle">Market Based</div>
                        <div className="smallCardBody">{condionVehicleDetails &&
                              condionVehicleDetails?.marketBasedPrice ? (
                                <CurrencyFormat
                                  value={parseFloat(
                                    condionVehicleDetails?.marketBasedPrice
                                  ).toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              ) : (
                                "$0.00"
                              )}</div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={4}>
                    <Card className="ConditionCard">
                      <CardContent>
                        <div className="smallCardTitle">Inspection Grade</div>
                        <div className="smallCardBody">
                          {condionVehicleDetails?.condition_grade}
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item md={4}>
                    <Card className="ConditionCard">
                      <CardContent>
                        <div className="smallCardTitle">Odometer</div>
                        <div className="smallCardBody">
                          {condionVehicleDetails?.inspection_mileage && `${milesFormatter.format(condionVehicleDetails?.inspection_mileage)} MI`}
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item md={12}>
                    <Box mt={2}>
                      <Card>
                        <Box p={2}>
                          <Typography variant="h6">Vehicle Details</Typography>
                          <hr />
                          <CardContent>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> VIN </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">{vin}</span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold">
                                    {" "}
                                    Inspection Date{" "}
                                  </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {moment(
                                    condionVehicleDetails?.inspection_date
                                  ).format("MM/DD/YYYY")}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold">
                                    {" "}
                                    Inspection Location{" "}
                                  </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.location_name}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle1">
                                  <span>.</span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.location_address}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span>.</span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.location_address2}
                                  {condionVehicleDetails?.location_city}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle1">
                                  <span> . </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.location_state}-
                                  {condionVehicleDetails?.location_zip}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle1">
                                  <span> . </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.location_phone}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Consignor </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.consignor}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Engine </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.engine_cylinder}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Door </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.doors}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Body Style </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.body_style}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Transmission </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.transmission_type}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Drive Train </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.driveTrain}
                                </span>                               
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Exterior color </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.ext_color}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Interior Type </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.interior_material}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Interior color </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.int_color}
                                </span>
                              </ListItemSecondaryAction>
                            </List>

                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Keys </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  Master: {condionVehicleDetails?.keys?.keys}/ Valet:{" "}
                                  {condionVehicleDetails?.keys?.valet}
                                </span>
                                <span className="textSize">
                                  Smart Key: {condionVehicleDetails?.keys?.smartKey}{" "}
                                  / Remotes:
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold">
                                    {" "}
                                    Grounding Mileage{" "}
                                  </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails &&
                                  condionVehicleDetails?.grounding_mileage && `${milesFormatter.format(condionVehicleDetails?.grounding_mileage)} MI`}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Account Type </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {" "}
                                  {condionVehicleDetails?.account_type}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                            <List className="paddingCSS">
                              <ListItemText>
                                <span className="textStyle">
                                  <span className="textBold"> Odor </span>
                                </span>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <span className="textSize">
                                  {condionVehicleDetails?.odor === "true"
                                    ? "Yes"
                                    : "None"}
                                </span>
                              </ListItemSecondaryAction>
                            </List>
                          </CardContent>

                          <CardContent>
                            <Typography variant="h6">Accessories</Typography>
                            <hr />
                            <Box className="accessoriestextStyle">
                              {accessoryDetails?.length > 0 &&
                                accessoryDetails.map((list, index) => {
                                  return (
                                    <Box
                                      className="accessoriestinlineextStyle"
                                      key={index}
                                    >
                                      <Typography>
                                        {list.description.toLowerCase()}
                                      </Typography>
                                    </Box>
                                  );
                                })}
                            </Box>
                          </CardContent>
                          <CardContent>
                            <Typography variant="h6">Build Data</Typography>
                            <hr />
                            <TableContainer component={Paper}>
                              <Table
                                className="table"
                                size="small"
                                aria-label="a dense table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Code</TableCell>
                                    <TableCell align="left">Description</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {OEMBuildDetailsData && OEMBuildDetailsData?.map((list, index) => {
                                    return (
                                      <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                          {list.accessory_code}
                                        </TableCell>
                                        <TableCell align="left">
                                          {list.description}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </CardContent>
                          <CardContent>
                            <Typography variant="h6">Wheels and Tires</Typography>
                            <hr />
                            <TableContainer component={Paper}>
                              <Table
                                className="table"
                                size="small"
                                aria-label="a dense table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Location</TableCell>
                                    <TableCell>Brand</TableCell>
                                    <TableCell>Size</TableCell>
                                    <TableCell>Wheel</TableCell>
                                    <TableCell>Tread Depth </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {wheelTiresDetails && wheelTiresDetails?.map((list, index) => {
                                    return (
                                      <TableRow key={index}>
                                        <TableCell align="left">
                                          {
                                            list.inspectionWheelTiresId
                                              .tire_location
                                          }
                                        </TableCell>
                                        <TableCell align="left">
                                          {list.manufracturer}
                                        </TableCell>
                                        <TableCell align="left">
                                          {list.size}
                                        </TableCell>
                                        <TableCell align="left">
                                          {list.wheel}
                                        </TableCell>
                                        <TableCell align="left">
                                          {list.tread}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </CardContent>
                          <div className="disclaimerVRS">
                            Disclaimer: The parts, equipment, accessories, and other
                            information listed above are based on
                            equipment/configuration at the time vehicle was sold by
                            Mazda Motor Corporation to a dealer and does not mean
                            that this vehicle is still so equipped.
                          </div>
                        </Box>
                      </Card>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box className="right-sidebar">
            {pageName === 'Manual Pricing' ? <UpdateMileagePricing vin={vin} hidden="Mileage" /> : null}
            {pageName === 'RRMApproval' ? <UpdateMileagePricing vin={vin} hidden="Mileage" /> : null}
            {pageName === 'Mileage Discrepencies' ? <UpdateMileagePricing vin={vin} hidden="Pricing" /> : null}
            {pageName === 'Arbitration Review' ? <ArbitrationReviewpage vin={props?.history?.location?.state?.vehicleDetails?.arbitrationId} hidden="Pricing" /> : null}
          </Box>
        </Box>
        <ViewDetailedReport
          DamageDetails={DamageDetails}
          open={open}
          close={handleClose}
          {...condionVehicleDetails}
        />
      </Box>
    </>
  );
}
